import { Instagram, Facebook, Linkedin, Phone, Mail } from "lucide-react";

const SOCIALS = [
    { icon: Instagram, label: "Allen G. Orchestra on Instagram", href: "http://instagram.com/allengorchestra", testId: "footer-instagram-link" },
    { icon: Facebook, label: "Allen G. Orchestra on Facebook", href: "http://www.facebook.com/AGNOrchestra", testId: "footer-facebook-link" },
    { icon: Linkedin, label: "Allen G. Nazarian on LinkedIn", href: "https://www.linkedin.com/in/allen-g-nazarian-00901a10b", testId: "footer-linkedin-link" },
];

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0c0c0f]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
            <div>
                <img src="/assets/ag-monogram-gold.png" alt="Allen G. Orchestra logo" data-testid="footer-logo" className="h-14 w-auto mb-5" />
                <p className="font-serif text-2xl text-[#fafafa]">Allen G. <span className="text-[#d4af37]">Orchestra</span></p>
                <p className="mt-4 text-sm text-[#a1a1aa] leading-relaxed max-w-xs">
                    The premier choice for extraordinary live wedding music in Los Angeles and throughout the world.
                </p>
            </div>
            <div>
                <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">Contact</p>
                <a href="tel:+13108770250" data-testid="footer-call-link"
                    className="flex items-center gap-3 text-sm text-[#fafafa] hover:text-[#d4af37] transition-colors duration-300">
                    <Phone size={15} className="text-[#d4af37]" /> 310.877.0250
                </a>
                <a href="mailto:Info@agnmusic.com" data-testid="footer-email-link"
                    className="mt-3 flex items-center gap-3 text-sm text-[#fafafa] hover:text-[#d4af37] transition-colors duration-300">
                    <Mail size={15} className="text-[#d4af37]" /> Info@agnmusic.com
                </a>
                <p className="mt-3 text-sm text-[#a1a1aa]">Beverly Hills, California</p>
            </div>
            <div>
                <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">Follow</p>
                <div className="flex gap-3">
                    {SOCIALS.map((s) => (
                        <a key={s.testId} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                            data-testid={s.testId}
                            className="inline-flex items-center justify-center w-10 h-10 border border-white/15 text-[#a1a1aa] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors duration-300">
                            <s.icon size={16} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs tracking-[0.15em] text-[#71717a] uppercase">
                    &copy; {new Date().getFullYear()} Allen G. Orchestra
                </p>
                <p className="text-xs tracking-[0.15em] text-[#71717a] uppercase">Since 2007 &middot; Los Angeles &middot; Worldwide</p>
            </div>
        </div>
    </footer>
);
